import React from 'react';
import { FormControl, Select, MenuItem, InputLabel } from '@mui/material';

function HandleSelector({ value, onChange, handles, sx, fullWidth, disabled, label = "Handle", ariaLabel = "Select handle" }) {
    return (
        <FormControl sx={{ minWidth: 400, maxWidth: 400, ...sx }} fullWidth={fullWidth} disabled={disabled}>
            <InputLabel>{label}</InputLabel>
            <Select
                value={value || ''}
                onChange={onChange}
                label={label}
                displayEmpty
                aria-label={ariaLabel}
            >
                {(handles ?? []).map(handle => {
                    return <MenuItem key={handle.handle} value={handle.handle}>{handle.handle}</MenuItem>
                })}
            </Select>
        </FormControl>
    );
}

export default HandleSelector;

